import React from 'react';
import Logger from '../../Logger.js';
import Loader from '../Loader';
import AppVars from '../../AppVars.js';
import TOMissingPhoneView from '../Views/TO/Login/MissingPhoneView'
import TOMissingEmailAndPhoneView from '../Views/TO/Login/MissingEmailAndPhoneView';
import TOMissingEmailPhoneNameView from '../Views/TO/Login/MissingEmailPhoneNameView'
import TOMissingPhoneNameView from '../Views/TO/Login/MissingPhoneNameView'

import {parseCookies, validateSessionToken, isValidGoToURL} from 'account-portal-library/lib/helperFunctions';
import {finishGoogleRegistration} from 'account-portal-library/lib/googleSignIn';
import {finishFacebookRegistration} from 'account-portal-library/lib/facebookSignIn';
import {validateObject} from 'account-portal-library/lib/idmSocialRegister';
import { getGotoUrlFromCookies } from '../../gotoUrl.js';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const INPUT_VALIDATION = {
    "FIRST_NAME" : "^[a-zA-Z][a-zA-Z\\s'\-]{0,12}[a-zA-Z]$",
    "LAST_NAME" : "^[a-zA-Z][a-zA-Z\\s'\-]{0,27}[a-zA-Z]$",
    "PHONE" : "^(?!0)[0-9]{10}$",
    "EMAIL" : "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

class MissingFields extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
            loading: false,
            isResponseValid: null,
            successfulRegistration: false,

            mail: null,
            telephoneNumber: null,
            firstName: null,
            lastName: null,

            isEmailValid: null,
            isEmailAvailable: true,
            emailFocus: false,
            floatEmail: true,


            isPhoneValid: null,
            isPhoneAvailable: true,
            phoneFocus: false,
            floatPhone: true,

            isFirstNameValid: null,
            firstNameFocus: false,
            floatFirstName: true,

            isLastNameValid: null,
            lastNameFocus: false,
            floatLastName: true

        }
        this.handleMissingFieldsFormSubmit = this.handleMissingFieldsFormSubmit.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.setFocusPhone = this.setFocusPhone.bind(this);
        this.removeFocusPhone = this.removeFocusPhone.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.setFocusEmail = this.setFocusEmail.bind(this);
        this.removeFocusEmail = this.removeFocusEmail.bind(this);
        this.GoogleSubmit = this.GoogleSubmit.bind(this);
        this.FacebookSubmit = this.FacebookSubmit.bind(this);
        this.onBlurPhone = this.onBlurPhone.bind(this);
        this.onBlurEmail = this.onBlurEmail.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.setFocusFirstName = this.setFocusFirstName.bind(this);
        this.removeFocusFirstName = this.removeFocusFirstName.bind(this);
        this.onBlurFirstName = this.onBlurFirstName.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.setFocusLastName = this.setFocusLastName.bind(this);
        this.removeFocusLastName = this.removeFocusLastName.bind(this);
        this.onBlurLastName = this.onBlurLastName.bind(this);

    }

    handlePhoneChange(event) {
        this.setState({
            telephoneNumber: event.target.value
        }, () => {
            if (!this.state.isPhoneAvailable) {
                this.setState({
                    isPhoneAvailable: true,
                    isPhoneValid: this.validateInput(this.state.telephoneNumber, "PHONE")
                })
            } else {
                this.setState({
                    isPhoneValid: this.validateInput(this.state.telephoneNumber, "PHONE")
                })
            }
        })
    }

    handleEmailChange(event) {
        this.setState({
            mail: event.target.value
        }, () => {
            if (!this.state.isEmailAvailable) {
                this.setState({
                    isEmailAvailable: true,
                    isEmailValid: this.validateInput(this.state.mail, "EMAIL")
                })
            } else {
                this.setState({
                    isEmailValid: this.validateInput(this.state.mail, "EMAIL")
                })
            }
        })
    }

    handleFirstNameChange(event){
        this.setState({
            firstName: event.target.value
        })
        this.setState({
            isFirstNameValid: this.validateInput(this.state.firstName, "FIRST_NAME")
        })
    }

    handleLastNameChange(event){
        this.setState({
            lastName: event.target.value
        })
        this.setState({
            isLastNameValid: this.validateInput(this.state.lastName, "LAST_NAME")
        })
    }




    validateInput(inputValue, inputType){
        const regex = RegExp(INPUT_VALIDATION[inputType])
        if (regex.test(inputValue)){
            return true;
        }
        return false;
    }

    validateFormInput() {
        let valid = true;
        if (this.state.registerFields.includes("EMAIL")) {
            valid = this.state.isEmailValid && valid
        }
        if (this.state.registerFields.includes("PHONE")) {
            valid = this.state.isPhoneValid && valid
        }
        if (this.state.registerFields.includes("FIRST")) {
            valid = this.state.isFirstNameValid && valid
        }
        if (this.state.registerFields.includes("LAST")) {
            valid = this.state.isLastNameValid && valid
        }
        return valid;
    }

    setFocusPhone(event){
        this.setState({phoneFocus: true})
        this.setState({floatPhone: false})
    }

    removeFocusPhone(){
        this.setState({phoneFocus: false})
    }

    onBlurPhone(){
        if(this.state.telephoneNumber === ""){
            this.setState({floatPhone: true})
        }else{
            this.setState({floatPhone: false})
        }
        this.removeFocusPhone();
        this.setState({
            isPhoneValid: this.validateInput(this.state.telephoneNumber, "PHONE")
        })
    }

    setFocusEmail(event){
        this.setState({emailFocus: true})
        this.setState({floatEmail: false})
    }

    removeFocusEmail(){
        this.setState({emailFocus: false})
    }

    onBlurEmail(){
        if(this.state.mail === ""){
            this.setState({floatEmail: true})
        }else{
            this.setState({floatEmail: false})
        }
        this.removeFocusEmail();
        this.setState({
            isEmailValid: this.validateInput(this.state.mail, "EMAIL")
        })
    }

    setFocusFirstName(event){
        this.setState({firstNameFocus: true})
        this.setState({floatFirstName: false})
    }

    removeFocusFirstName(){
        this.setState({firstNameFocus: false})
    }

    onBlurFirstName(){
        if(this.state.firstName === ""){
            this.setState({floatFirstName: true})
        }else{
            this.setState({floatFirstName: false})
        }
        this.removeFocusFirstName();
        this.setState({
            isFirstNameValid: this.validateInput(this.state.firstName, "FIRST_NAME")
        })
    }

    setFocusLastName(event){
        this.setState({lastNameFocus: true})
        this.setState({floatLastName: false})
    }

    removeFocusLastName(){
        this.setState({lastNameFocus: false})
    }

    onBlurLastName(){
        if(this.state.lastName === ""){
            this.setState({floatLastName: true})
        }else{
            this.setState({floatLastName: false})
        }
        this.removeFocusLastName();
        this.setState({
            isLastNameValid: this.validateInput(this.state.lastName, "LAST_NAME")
        })
    }

    async checkToken(loginResponse){
        try {
            const tokenId = loginResponse.response.tokenId
            if (tokenId != null){
                logger.log("test", tokenId)
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else{
                return false
            }
        }
        catch{
            return false
        }
        
    }

    async handleMissingFieldsFormSubmit(event) {
        event.preventDefault();
        this.setState({loading: true})

        const valid = this.validateFormInput()

        if (valid) {
            const validateObjectResponse = await validateObject(appVars.getIDMBaseURL(), this.state.mail, this.state.telephoneNumber)
            if (validateObjectResponse.error){
                this.setState({isResponseValid: false})
                this.setState({loading: false})
            } else{
                this.setState({isPhoneAvailable: validateObjectResponse.isPhoneAvailable})
                this.setState({isEmailAvailable: validateObjectResponse.isEmailAvailable})
            }

            if (validateObjectResponse.isPhoneAvailable && validateObjectResponse.isEmailAvailable){
                if (this.state.provider === 'google'){
                    this.GoogleSubmit()
                } else if ( this.state.provider === 'facebook'){
                    this.FacebookSubmit()
                }
            } else {
                this.setState({loading: false})
            }
        } else {
            this.setState({loading: false})
        }
    }


    async GoogleSubmit(){
        const finishRegistrationResponse =  await finishGoogleRegistration(this.props.inputCallback, this.state.telephoneNumber, this.state.firstName, this.state.lastName, this.props.style, appVars.getBaseUrl(), appVars.getRealm(), appVars.getName())
        if (finishRegistrationResponse.error) {
            // if bad figure out what to show
            logger.log("test", 'error finishing social registration in auth tree');
            logger.log('test', finishRegistrationResponse)
            logger.log('test', finishRegistrationResponse.error)
            this.setState({
                loading: false,
                isResponseValid: false
            })
        } else {
            // check the response, - set the reg state if successful and try to log them in, show them the hey you need to verify page, or simply the successful registration page with a prompt to log in?
            const validToken = await this.checkToken(finishRegistrationResponse)
            if (validToken) {
                // set successfulRegistration? redirect somewhere else?? sign in???
                this.setState({
                    loading: false,
                    successfulRegistration: true
                })
            } else {
                this.setState({
                    loading: false,
                    isResponseValid: false
                })
            }
        }
    }

    async FacebookSubmit(){
        const finishRegistrationResponse = await finishFacebookRegistration(this.props.inputCallback, this.state.mail, this.state.telephoneNumber, this.state.firstName, this.state.lastName, this.props.style, appVars.getBaseUrl(), appVars.getRealm(), appVars.getName());
        
        if (finishRegistrationResponse.error) {
            // if bad figure out what to show
            logger.log("test", 'error finishing social registration in auth tree');
            logger.log('test', finishRegistrationResponse)
            logger.log('test', finishRegistrationResponse.error)
            this.setState({
                loading: false,
                isResponseValid: false
            })
        } else {
            // check the response, - set the reg state if successful and try to log them in, show them the hey you need to verify page, or simply the successful registration page with a prompt to log in?
            const validToken = await this.checkToken(finishRegistrationResponse)
            if (validToken) {
                // set successfulRegistration? redirect somewhere else?? sign in???
                this.setState({
                    loading: false,
                    successfulRegistration: true
                })
            } else {
                this.setState({
                    loading: false,
                    isResponseValid: false
                })
            }
        }
    }

    render (){
        if (this.state.loading === true) {
            return <Loader />
        } 
        else if (this.state.successfulRegistration === true) {
            const gotoUrl = getGotoUrlFromCookies(['T']);
            navigateWithAnalytics(gotoUrl, "cookie-redirect", "auto");
            return "";
        }
        else if (this.state.registerFields.length === 1) {
                return(
                    <TOMissingPhoneView
                    style = {this.props.style}
                    telephoneNumber = {this.state.telephoneNumber}
                    isPhoneValid = {this.state.isPhoneValid}
                    isPhoneAvailable = {this.state.isPhoneAvailable}                
                    isResponseValid = {this.state.isResponseValid}
                    handlePhoneChange = {this.handlePhoneChange}
                    handleMissingFieldsFormSubmit = {this.handleMissingFieldsFormSubmit}
                    phoneFocus = {this.state.phoneFocus}
                    setFocusPhone = {this.setFocusPhone}
                    removeFocusPhone = {this.removeFocusPhone}
                    provider = {this.props.provider}
                    onBlurPhone = {this.onBlurPhone}
                    floatPhone = {this.state.floatPhone}
                    />
                )
            
        } else if (this.state.registerFields.length === 2) {
                return(
                    <TOMissingEmailAndPhoneView
                    style = {this.props.style}
                    mail = {this.state.mail}
                    isEmailValid = {this.state.isEmailValid}
                    isEmailAvailable = {this.state.isEmailAvailable}
                    handleEmailChange = {this.handleEmailChange}
                    emailFocus = {this.state.emailFocus}
                    setFocusEmail = {this.setFocusEmail}
                    removeFocusEmail = {this.removeFocusEmail}
                    telephoneNumber = {this.state.telephoneNumber}
                    isPhoneValid = {this.state.isPhoneValid}
                    isPhoneAvailable = {this.state.isPhoneAvailable}                
                    isResponseValid = {this.state.isResponseValid}
                    handlePhoneChange = {this.handlePhoneChange}
                    handleMissingFieldsFormSubmit = {this.handleMissingFieldsFormSubmit}
                    phoneFocus = {this.state.phoneFocus}
                    setFocusPhone = {this.setFocusPhone}
                    removeFocusPhone = {this.removeFocusPhone}
                    provider = {this.props.provider}
                    onBlurEmail = {this.onBlurEmail}
                    onBlurPhone = {this.onBlurPhone}
                    floatEmail = {this.state.floatEmail}
                    floatPhone = {this.state.floatPhone}
                    />
                )
            
        } else if (this.state.registerFields.length === 3){
            return(
                <TOMissingPhoneNameView 
                style = {this.props.style}
                provider = {this.props.provider}
                handleMissingFieldsFormSubmit = {this.handleMissingFieldsFormSubmit}
                isResponseValid = {this.state.isResponseValid}

                telephoneNumber = {this.state.telephoneNumber}
                isPhoneValid = {this.state.isPhoneValid}
                isPhoneAvailable = {this.state.isPhoneAvailable}                
                handlePhoneChange = {this.handlePhoneChange}
                phoneFocus = {this.state.phoneFocus}
                setFocusPhone = {this.setFocusPhone}
                removeFocusPhone = {this.removeFocusPhone}
                onBlurPhone = {this.onBlurPhone}
                floatPhone = {this.state.floatPhone}

                firstName = {this.state.firstName}
                handleFirstNameChange = {this.handleFirstNameChange}
                isFirstNameValid = {this.state.isFirstNameValid}
                setFocusFirstName = {this.setFocusFirstName}
                removeFocusFirstName = {this.removeFocusFirstName}
                firstNameFocus = {this.state.firstNameFocus}
                onBlurFirstName = {this.onBlurFirstName}
                floatFirstName = {this.state.floatFirstName}

                lastName = {this.state.lastName}
                handleLastNameChange = {this.handleLastNameChange}
                isLastNameValid = {this.state.isLastNameValid}
                setFocusLastName = {this.setFocusLastName}
                removeFocusLastName = {this.removeFocusLastName}
                lastNameFocus = {this.state.lastNameFocus}
                onBlurLastName = {this.onBlurLastName}
                floatLastName = {this.state.floatLastName}
                />
            )
        } else{
            return(
                <TOMissingEmailPhoneNameView 
                style = {this.props.style}
                provider = {this.props.provider}
                isResponseValid = {this.state.isResponseValid}
                handleMissingFieldsFormSubmit = {this.handleMissingFieldsFormSubmit}

                mail = {this.state.mail}
                handleEmailChange = {this.handleEmailChange}
                isEmailValid = {this.state.isEmailValid}
                isEmailAvailable = {this.state.isEmailAvailable}
                setFocusEmail = {this.setFocusEmail}
                removeFocusEmail = {this.removeFocusEmail}
                emailFocus = {this.state.emailFocus}
                onBlurEmail = {this.onBlurEmail}
                floatEmail = {this.state.floatEmail}

                telephoneNumber = {this.state.telephoneNumber}
                handlePhoneChange = {this.handlePhoneChange}
                isPhoneValid = {this.state.isPhoneValid}
                isPhoneAvailable = {this.state.isPhoneAvailable}                
                setFocusPhone = {this.setFocusPhone}
                removeFocusPhone = {this.removeFocusPhone}
                phoneFocus = {this.state.phoneFocus}
                onBlurPhone = {this.onBlurPhone}
                floatPhone = {this.state.floatPhone}

                firstName = {this.state.firstName}
                handleFirstNameChange = {this.handleFirstNameChange}
                isFirstNameValid = {this.state.isFirstNameValid}
                setFocusFirstName = {this.setFocusFirstName}
                removeFocusFirstName = {this.removeFocusFirstName}
                firstNameFocus = {this.state.firstNameFocus}
                onBlurFirstName = {this.onBlurFirstName}
                floatFirstName = {this.state.floatFirstName}

                lastName = {this.state.lastName}
                handleLastNameChange = {this.handleLastNameChange}
                isLastNameValid = {this.state.isLastNameValid}
                setFocusLastName = {this.setFocusLastName}
                removeFocusLastName = {this.removeFocusLastName}
                lastNameFocus = {this.state.lastNameFocus}
                onBlurLastName = {this.onBlurLastName}
                floatLastName = {this.state.floatLastName}
                />
            )
        }
    }
    


}

export default MissingFields;